import { auth } from "../firebase"

export function refreshAuthToken(){
    return auth.currentUser.getIdToken(true)
}